/* eslint-disable import/prefer-default-export */
import { useQuery } from '@apollo/client';

export function useFetchGraphQL(query, variables = {}, options = {}) {
  const defaultOptions = {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  };

  const { loading, error, data, refetch } = useQuery(query, {
    variables,
    ...defaultOptions,
    ...options,
  });

  return {
    loading,
    error,
    data,
    refetch,
    isError: !!error,
  };
}
